import { OnboardingProps } from './Onboarding.type';

const Onboarding = ({ title, content }: OnboardingProps) => {
  const handleButton = (url: string) => {
    window.location.href = url;
  };

  return (
    <div className="onboarding-container">
      <h1>{title}</h1>
      <div className="onboarding-card-container">
        {content.map((item) => (
          <div
            key={item?.title || item?.description}
            className="onboarding-card"
          >
            {item.icon}
            {item.title && <h3>{item.title}</h3>}
            {item.description && <p>{item.description}</p>}
            {item.buttonLabel && (
              <button
                type="button"
                onClick={() => handleButton(item.url)}
                className="onboarding-btn"
              >
                {item.buttonLabel}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Onboarding;
